export default {
    inject: [
        'SwagCmsExtensionsFormValidationService',
    ],

    beforeCreate() {
        Shopware.Store.get('swCmsDetailCurrentCustomForm').$reset();
    },

    methods: {
        onSave() {
            const forms = [];

            this.page.sections.forEach((section) => {
                section.blocks.forEach((block) => {
                    block.slots.forEach((slot) => {
                        if (!Shopware.Utils.object.hasOwnProperty(slot, 'extensions') ||
                            !Shopware.Utils.object.hasOwnProperty(slot.extensions, 'swagCmsExtensionsForm')
                        ) {
                            return;
                        }

                        forms.push(slot.extensions.swagCmsExtensionsForm);
                    });
                });
            });

            return this.SwagCmsExtensionsFormValidationService.validateAllForms(forms).catch(() => {
                this.createNotificationError({
                    message: this.$tc('swag-cms-extensions.sw-cms.detail.errors.customFormConfigurationInvalid'),
                });

                return Promise.reject();
            }).then(() => {
                return this.$super('onSave');
            });
        },

        async onBlockDuplicate(block, parameters) {
            if (block.type !== 'custom-form') {
                return this.$super('onBlockDuplicate', block, parameters);
            }

            const swagCmsExtensionsForm = block.slots[0].extensions.swagCmsExtensionsForm;
            const technicalNameOverride = this.createCloneName(swagCmsExtensionsForm.technicalName);
            const mailTemplateId = swagCmsExtensionsForm.mailTemplateId;
            const behavior = {
                overwrites: {
                    position: block.position + 1,
                    ...this.createCustomFormDuplicateOverride(technicalNameOverride, mailTemplateId),
                },
                cloneChildren: true,
            };

            try {
                const { id: clonedBlockId } = await this.blockRepository.clone(block.id, behavior)
                const clonedBlock = await this.blockRepository.get(clonedBlockId);

                const section = this.page.sections[parameters.position];
                section.blocks.splice(clonedBlock.position, 0, clonedBlock);

                this.updateBlockPositions(section);
                this.onSave();
            } catch (e) {
                this.createNotificationError({
                    message: this.$tc('global.notification.unspecifiedSaveErrorMessage'),
                });
            }
        },

        async onSectionDuplicate(section) {
            // The clone route compares the behavior with uuid-sorted database entries. Therefore, we must sort here as well.
            const sortedBlocks = [...section.blocks].sort((a,b) => a.id.localeCompare(b.id));
            const blockOverrides = sortedBlocks.reduce((accumulator, block, index) => {
                if (block.type === 'custom-form') {
                    const swagCmsExtensionsForm = block.slots[0].extensions.swagCmsExtensionsForm;
                    const technicalNameOverride = this.createCloneName(swagCmsExtensionsForm.technicalName);
                    const mailTemplateId = swagCmsExtensionsForm.mailTemplateId;
                    accumulator[index] = this.createCustomFormDuplicateOverride(technicalNameOverride, mailTemplateId);
                }

                return accumulator;
            }, {});

            if (Object.values(blockOverrides).length <= 0) {
                return this.$super('onSectionDuplicate', section);
            }

            const behavior = {
                overwrites: {
                    position: section.position + 1,
                    blocks: blockOverrides,
                },
                cloneChildren: true,
            };

            try {
                const { id: clonedSectionId } = await this.sectionRepository.clone(section.id, behavior)
                const clonedSection = await this.sectionRepository.get(clonedSectionId);
                this.page.sections.splice(clonedSection.position, 0, clonedSection);

                this.updateSectionAndBlockPositions(section);
                this.onSave();
            } catch (e) {
                this.createNotificationError({
                    message: this.$tc('global.notification.unspecifiedSaveErrorMessage'),
                });
            }
        },

        createCloneName(originalName) {
            return `${originalName}_${Shopware.Utils.createId().slice(-5)}`;
        },

        createCustomFormDuplicateOverride(technicalNameOverride, mailTemplateId) {
            return {
                slots: {
                    0: {
                        extensions: {
                            swagCmsExtensionsForm: {
                                technicalName: technicalNameOverride,
                                mailTemplateId,
                            },
                        },
                    },
                },
            };
        },
    },
}
